import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Skice dneva",
  "description": "",
  "published": "2006-07-08T00:00:00.000Z",
  "redirect_from": ["/blog/skice-dneva/swizec/399"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Se spomnite, dnevne skice... tiste, ki bi naj bile posodobljene vsak dan tamkaj pod sliko s kamere? No spremenile so se v sem-pa-tja skice, precej patetiÄno.`}</p>
    <p>{`Razlog ni, da bi bila oseba, ki jih riše lena ali še huje lenobno nastrojena, razlog je bolj v tem, da dan nekako nima dovolj ur, še veÄ, nima dovolj ur v katerih bi se dotiÄna oseba poÄutila dovolj kreativno. Odkar je potrebno vstajati ob šestih zjutraj, kolesariti na lekcije voÅ¾nje, voziti v neumnih in popolnoma nepomembnih smereh, kolesariti v sluÅ¾bo, biti produktiven deset ur, kolesariti domov in se nabasati s hranilnimi vrednostmi; nekako ne ostane veÄ veliko produktivnosti. NoÄi se po nenavadnih nakljuÄjih porabijo za spanje ali internet. Precej patetiÄno v bistvu.`}</p>
    <p>{`Le upamo lahko, da je bil ta teden nekakšna aklimacijska doba in se bo sedaj vse vrnilo nazaj v uteÄ‡ene tirnice. Vsaj dnevne skice upam, da bodo posodobljene vsak dan, bom paÄ popil še veÄ kofeiniranih stvari, da bo to realizirano.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      